export default "__VITE_ASSET__383b7c36__"